import { render, staticRenderFns } from "./shifts2.vue?vue&type=template&id=004e8072&"
import script from "./shifts2.vue?vue&type=script&lang=js&"
export * from "./shifts2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports